<app-spinner></app-spinner>
<div class="loginbox">
    <div *ngIf="deleteType.isUser" class="flabel">
        Would you like to delete this user account?
    </div>
    <div *ngIf="deleteType.isGroup" class="flabel">
        Would you like to delete this api group?
    </div>
    <div *ngIf="deleteType.isAttribute" class="flabel">
        Would you like to delete this attribute?
    </div>
    <div *ngIf="deleteType.isResponseMapping" class="flabel">
        Would you like to delete this responsemapping?
    </div>
    <div *ngIf="deleteType.isApi" class="flabel">
        Would you like to delete {{apiSourceName.sourceName}}?
    </div>
    <div *ngIf="deleteType.isCategory" class="flabel">
        Would you like to delete this category?
    </div>
    <div *ngIf="deleteType.isSubCategory" class="flabel">
        Would you like to delete this subcategory?
    </div>


    <div class="no" (click)="closedialog()">No</div>
    <div *ngIf="deleteType.isUser"
         style="width:50%"
         class="yes"
         (click)="deleteuser()">
        Yes
    </div>
    <div *ngIf="deleteType.isGroup"
         style="width:50%"
         class="yes"
         (click)="deletegroup()">
        Yes
    </div>
    <div *ngIf="deleteType.isAttribute"
         style="width:50%"
         class="yes"
         (click)="deleteAttribute()">
        Yes
    </div>

    <div *ngIf="deleteType.isCategory"
         style="width:50%"
         class="yes"
         (click)="deleteCategory()">
        Yes
    </div>
    <div *ngIf="deleteType.isSubCategory"
         style="width:50%"
         class="yes"
         (click)="deleteSubCategory()">
        Yes
    </div>



    <div *ngIf="deleteType.isResponseMapping"
         style="width:50%"
         class="yes"
         (click)="deleteResponse()">
        Yes
    </div>
    <div *ngIf="deleteType.isApi"
         style="width:50%"
         class="yes"
         (click)="deleteApidata()">
        Yes
    </div>
</div>
